var map = {
	"./sw.png": "s174",
	"./swHover.png": "OQzQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pu6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg ^\.\/sw.*\.png$
// module id = Pu6a
// module chunks = 1